import PolicyLossFile from './PolicyLossFile';

export default class PolicyLoss {

	public submitDate: Date | null = null;
	public lossDate: Date | null = null;
	public lossTime: string | null = null;
	public phone_Home: string | null = null;
	public filedBy: string | null = null;
	public estLoss: number | null = null;
	public otherInsurance: boolean | null = null;
	public isFirstLoss: boolean | null = null;
	public peril_Id: number | null = null;
	public contactNotes: string | null = null;
	public lossOccurred: string | null = null;
	public damageNotes: string | null = null;
	public claimsNotes: string | null = null;
	public priorLossDetails: string | null = null;
	public insuredEmail: string | null = null;
	public files: PolicyLossFile[] = [];

	public constructor() {
	}
};